import { Selectbox, SelectboxItem } from "@ionos-web-design-system/react"
import type { FieldValidator } from "final-form"
import { Field } from "react-final-form"

export type Option = {
  value: string
  label: string
  isDisabled?: boolean
}

export type FinalFormSelectboxProps = {
  name: string
  externalError?: string
  disabled?: boolean
  options: Option[]
  onValidate?: FieldValidator<string>
  initialValue?: string
  label?: string
  labelPosition?: "inside" | "top" | "left"
  className?: string
}

export default function FinalFormSelectbox({
  options,
  externalError,
  name,
  disabled,
  onValidate,
  initialValue,
  ...restProps
}: FinalFormSelectboxProps) {
  return (
    <Field
      initialValue={initialValue}
      validate={onValidate}
      name={name}
      render={({ input, meta }) => (
        <Selectbox
          {...restProps}
          name={name}
          value={input.value}
          onValueChange={input.onChange}
          disabled={disabled}
          validationState={
            (meta.touched && (meta.error || meta.submitError)) || externalError
              ? "error"
              : undefined
          }
          validationMessage={
            meta.touched && (meta.error || meta.submitError)
              ? meta.error || meta.submitError
              : externalError || undefined
          }
        >
          {options.map((item) => (
            <SelectboxItem
              key={item.value}
              value={item.value}
              disabled={item.isDisabled}
            >
              {item.label}
            </SelectboxItem>
          ))}
        </Selectbox>
      )}
    />
  )
}
